import { IconTile } from "@design";
import { Bot } from "lucide-react";

// The API stores an icon *name* + a brand color per agent. Rendering the
// stored color is user content (not a hardcoded palette violation); a
// dynamic icon-name map lands with the picker (plan: post-mock slice).
export function AgentIcon(_props: Readonly<{ icon: string }>) {
  return (
    <IconTile variant="neutral">
      <Bot size={16} aria-hidden />
    </IconTile>
  );
}
